<template>
	<CreationWizardStepHeaderWrapper v-bind="headerWrapperProps" v-on="headerWrapperListeners">
		<WizardStepHeaderWithRightSideWrapper>
			<div class="display-flex">
				<ToolHeaderTitle />
			</div>
			<template #right-side v-if="isFirstStep">
				<ChooseProjectDataProvider v-model="_selectedProjectId" auto-select-first />
			</template>
		</WizardStepHeaderWithRightSideWrapper>
	</CreationWizardStepHeaderWrapper>
</template>

<script>
import ToolHeaderTitle from '../common/ToolHeaderTitle.vue';
import WizardStepMixin from '../WizardStepMixin';
import props from './ChooseToolPlacement.props';
import WizardStepHeaderWithRightSideWrapper from '../common/WizardStepHeaderWithRightSideWrapper.vue';
import ChooseProjectHeaderMixin from '../common/ChooseProjectHeaderMixin';
export default {
	name: 'ChooseToolPlacementHeader',
	mixins: [WizardStepMixin, ChooseProjectHeaderMixin],
	props,
	components: { ToolHeaderTitle, WizardStepHeaderWithRightSideWrapper },
};
</script>

<style scoped lang="scss"></style>
